import { connect } from "react-redux";
import LocationType from "./../LocationType";
import _ from "lodash";
import KpiCheckbox from "./KpiCheckbox";
import { addKpi, removeKpi } from "./../../../../../redux/actions/surveyActions";

const mapStateToProps = (state, ownProps) => {
	//TODO selectors/reducers
	const surveyProgress = state.survey.surveyManager.surveyProgress;
	const locationTypes = surveyProgress.locationTypes || [];
	const locationTypeDataIndex = _.findIndex(locationTypes, {
		locationTypeId: ownProps.locationType.locationTypeId,
	});
	const locationTypeData =
		locationTypeDataIndex !== -1 ? locationTypes[locationTypeDataIndex] : {};
	const locationType = new LocationType(locationTypeData);

	const isKpiChecked = locationType.isKpiSelected(
		ownProps.statement,
		ownProps.kpi
	);

	const kpi = ownProps.kpi || {};
	const kpiStatements = kpi.statement_id || [];
	const statement = ownProps.statement || {};
	const display = kpiStatements.indexOf(statement.id) !== -1;
	return {
		display,
		checked: isKpiChecked,
		kpisList: state.survey.surveyManager.kpisList || [],
		kpisSelected: locationType.getKpisSelected(ownProps.statement) || [],
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		addKpi: ({ locationType, statement, kpi } = {}) => {
			dispatch(
				addKpi(
					locationType || ownProps.locationType,
					statement || ownProps.statement,
					kpi || ownProps.kpi
				)
			);
		},
		removeKpi: ({ locationType, statement, kpi } = {}) => {
			dispatch(
				removeKpi(
					locationType || ownProps.locationType,
					statement || ownProps.statement,
					kpi || ownProps.kpi
				)
			);
		},
	};
};
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(KpiCheckbox);



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepActionsKpi/SurveyStepActionsKpiTabElements/KpiCheckboxContainer.js